<template>
  <div class="animated_class">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Add Voucher</div>
      <router-link class="btn-blue" to="/vouchers/get-vouchers-merch"
        >{{ $t("voucher") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="row mb-3">
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucherObj.voucher_name"
                v-validate="{ required: 'required' }"
                name="voucher_name"
                id="voucher_name"
                placeholder="."
                type="text"
              />
              <label>Voucher Name</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_name')">{{
                errors.first("voucher_name")
              }}</span>
            </p>
          </div>
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucherObj.voucher_code"
                v-validate="{ required: 'required' }"
                name="voucher_code"
                id="voucher_code"
                placeholder="."
                type="text"
              />
              <label>Code</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_code')">{{
                errors.first("voucher_code")
              }}</span>
            </p>
          </div>
          <div class="col-lg-3 col-12">
            <div class="input-material">
              <input
                v-model="voucherObj.voucher_alt_name"
                name="voucher_receipt_print"
                id="voucher_receipt_print"
                placeholder="."
                type="text"
              />
              <label>Alternate Name</label>
            </div>
          </div>
          <div class="col-lg-3 col-12 align-self-center">
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="voucherObj.voucher_is_active"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{
                voucherObj.voucher_is_active === "Y" ? "Active" : "Deactive"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Voucher Specific Cinemas -->
        <div class="row mb-3">
          <div class="col-xl-3 col-lg-3 col-6">
            <div class="dropdown-curve-container">
              <label
                :class="
                  voucherObj.applicable_cinemas.length
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                v-model="voucherObj.applicable_cinemas"
                :options="cinemas"
                placeholder=""
                label="cine_name"
                track-by="cine_id"
                :searchable="true"
                :multiple="true"
              ></multiselect>
              <p class="text-danger">
                <span v-if="custom_errors.only_cinema_error">{{
                  custom_errors.only_cinema_error
                }}</span>
              </p>
            </div>
          </div>

          <div class="col-xl-3 col-lg-3 col-6">
            <div class="dropdown-curve-container">
              <label
                :class="
                  voucherObj.sales_channels.length
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
              >
                {{ $tc("Sales Channel") }}
              </label>
              <multiselect
                v-model="voucherObj.sales_channels"
                :options="userList"
                :close-on-select="false"
                placeholder=""
                label="user_name"
                isSingleId="user_id"
                :multiple="true"
                track-by="user_id"
              >
              </multiselect>
            </div>
          </div>

          <!-- <div class="col-xl-3 col-lg-3 col-6">
            <div class="dropdown-curve-container">
              <label :class="voucherObj.applicable_merchandises.length ? 'shift-up' : 'font-weight-bold'">
                {{ $tc("Merchandise") }}
              </label>
              <multiselect
              v-model="voucherObj.applicable_merchandises"
                    :options="AllMerchandiseItems"
                    :close-on-select="false"
                    placeholder=""
                    label="merchandise_name"
                    isSingleId="merchandise_id"
                    :multiple="true"
                    track-by="merchandise_id"
                >
              </multiselect>
            </div> 
          </div> -->
        </div>

        <!-- Voucher start/end time -->
        <div class="row mb-3">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="voucherObj.voucher_from_date"
                  v-on:click="voucherObj.voucher_from_date = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="voucherObj.voucher_from_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="voucher_startdate"
                    name="voucher_startdate"
                    :disabled-dates="disabledDates"
                    :title="$t('voucher_start_date_tooltip')"
                  ></Datepicker>
                </div>
                <label :class="voucherObj.voucher_from_date ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_start_date_error }}</span>
            </p>
          </div>

          <div class="col-lg-3 col-md-6 col-12">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="voucherObj.voucher_to_date"
                  v-on:click="voucherObj.voucher_to_date = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="voucherObj.voucher_to_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="voucher_enddate"
                    name="voucher_enddate"
                    :disabled-dates="disabledDates"
                    :title="$t('voucher_start_date_tooltip')"
                  >
                  </Datepicker>
                </div>
                <label :class="voucherObj.voucher_to_date ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_end_date_error }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="voucherObj.voucher_from_time"
                id="starttime"
                name="starttime"
                :placeholder="$tc('starttime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                :title="$t('voucher_start_time')"
              ></vue-timepicker>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_start_time_error }}</span>
            </p>
          </div>
          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="voucherObj.voucher_to_time"
                id="endtime"
                name="endtime"
                :placeholder="$tc('endtime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                :title="$t('voucher_end_time')"
              ></vue-timepicker>
            </div>
            <p class="text-danger">
              <span>{{ custom_errors.voucher_end_time_error }}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Voucher Configuration -->
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("configuration", 1) }}
        </div>
        <div class="row">
          <div
            class="internal-border"
            style="background-color: white; display: flex; justify-content: space-around;"
          >
            <!-- VOUCHER VALUE -->
            <div class="col-lg-3 col-xl-2 d-flex align-items-center mb-3">
              <span>{{ $tc("value") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucherObj.voucher_amount"
                  v-validate="'required|decimal'"
                  name="voucher_amt"
                  id="voucher_amt"
                  type="text"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_amt')">{{
                  errors.first("voucher_amt")
                }}</span>
              </p>
            </div>

            <!-- IS PERCENTAGE -->
            <div
              class="col-lg-3 col-xl-2 d-flex align-items-center mb-3"
              style="margin-left: -50px;"
            >
              <span>{{ $t("Percentage") }}</span>
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="voucherObj.is_percantage"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
            </div>

            <!-- MIN BILL AMOUNT -->
            <div
              class="col-lg-3 col-xl-2 d-flex align-items-center mb-3"
              style="margin-left: -50px;"
            >
              <span style="white-space: nowrap;" s>Min Bill/Total amt.</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucherObj.min_bill_amount"
                  v-validate="'required|numeric'"
                  name="voucher_min_amt"
                  id="voucher_min_amt"
                  type="text"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_min_amt')">{{
                  errors.first("voucher_min_amt")
                }}</span>
              </p>
            </div>

            <!-- MAX BILL AMOUNT -->
            <div
              style="margin-left: 30px;"
              class="col-lg-3 col-xl-2 d-flex align-items-center mb-3"
              v-if="voucherObj.is_percantage == 'Y'"
            >
              <span>{{ $tc("Max") }} {{ $tc("discount") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucherObj.max_redemption_amount"
                  v-validate="'required|numeric'"
                  name="voucher_max_amt"
                  id="voucher_max_amt"
                  type="text"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_max_amt')">{{
                  errors.first("voucher_max_amt")
                }}</span>
              </p>
            </div>

            <!-- TOTAL REDEMPTION -->
            <div class="col-lg-3 col-xl-2 d-flex align-items-center mb-3">
              <span>Total {{ $tc("redemption") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  style="text-align: right"
                  v-model="voucherObj.total_redemption"
                  type="text"
                  name="redemption"
                  id="redemption"
                  v-validate="'required|numeric'"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('redemption')">{{
                  errors.first("redemption")
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4 text-center">
        <button @click="OnFinalSubmit()" class="btn-blue">
          {{ $t("generate") }} {{ $t("voucher") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MarketingService from "@/services/MarketingService";
  import DatePicker from "vue2-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import moment from "moment";

  let initialStartDate = moment(
    `${moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD")} 24:00:00`
  ).format();

  export default {
    components: { DatePicker, VueTimepicker },
    data() {
      return {
        voucherObj: {
          m_voucher_id: null,
          voucher_name: "",
          voucher_alt_name: "",
          voucher_code: "",
          voucher_amount: null,
          is_percantage: "Y",
          min_bill_amount: null,
          max_redemption_amount: null,
          total_redemption: null,
          voucher_from_date: null,
          voucher_from_time: "00:00",
          voucher_to_date: null,
          voucher_to_time: "23:59",
          voucher_is_active: "Y",
          applicable_cinemas: [],
          sales_channels: [],
          // applicable_merchandises:[]
        },
        cinemas: [],
        userList: [],
        disabledDates: {
          to: new Date(Date.now() - 8640000),
        },
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
        submitted: false,
        custom_errors: {
          only_cinema_error: "",
          weekday_errors: "",
          voucher_start_date_error: "",
          voucher_end_date_error: "",
          voucher_start_time_error: "",
          voucher_end_time_error: "",
        },
        AllMerchandiseItems: [],
      };
    },
    mounted() {
      Promise.all([
        this.getCinemas(),
        this.getUserList(),
        this.getMerchandiseItems(),
      ]).then(() => {});
    },
    computed: {},
    watch: {},
    methods: {
      moment,
      async getUserList() {
        this.userList = [];
        try {
          const response = await MarketingService.GETUSERLIST();
          const { data } = response;
          //console.log("response", response)
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.userList = data.Records;
            //console.log("this.userList",this.userList)
          }
        } catch (error) {
          console.log(error, "from cinemas");
        }
      },
      getMerchandiseItems: function() {
        this.AllMerchandiseItems = [];
        let payload = {
          tableName: "ms_merchandise",
          merchandise_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.AllMerchandiseItems = data.Records;
                // console.log("this.AllMerchandiseItems", this.AllMerchandiseItems )
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      validateVoucherAmount() {
        const amount = this.voucherObj.voucher_amount;
        const minBillAmount = this.voucherObj.min_bill_amount;
        const max_redemption_amount = this.voucherObj.max_redemption_amount;
        const total_redemption = this.voucherObj.total_redemption;
        //voucher_amount
        if (amount === null || amount === "" || amount === undefined) {
          this.$toasted.show("Please enter voucher amount");
          return false;
        }
        if (isNaN(amount) || !isFinite(amount)) {
          this.$toasted.show("Voucher amount must be a number");
          return false;
        }
        //voucher_amount

        //min_bill_amount
        if (
          minBillAmount === null ||
          minBillAmount === "" ||
          minBillAmount === undefined
        ) {
          this.$toasted.show("Please enter minimum bill amount");
          return false;
        }
        if (
          minBillAmount !== null &&
          minBillAmount !== "" &&
          minBillAmount !== undefined
        ) {
          if (isNaN(minBillAmount) || !isFinite(minBillAmount)) {
            this.$toasted.show("Minimum bill amount must be a number");
            return false;
          }
        }
        //min_bill_amount

        //max_redemption_amount
        if (
          max_redemption_amount === null ||
          max_redemption_amount === "" ||
          max_redemption_amount === undefined
        ) {
          this.$toasted.show("Please enter maximum discount amount");
          return false;
        }
        if (
          max_redemption_amount !== null &&
          max_redemption_amount !== "" &&
          max_redemption_amount !== undefined
        ) {
          if (
            isNaN(max_redemption_amount) ||
            !isFinite(max_redemption_amount)
          ) {
            this.$toasted.show("Maximum bill amount must be a number");
            return false;
          }
        }
        //max_redemption_amount

        //total_redemption
        if (
          total_redemption === null ||
          total_redemption === "" ||
          total_redemption === undefined
        ) {
          this.$toasted.show("Please enter total redemption");
          return false;
        }
        if (
          total_redemption !== null &&
          total_redemption !== "" &&
          total_redemption !== undefined
        ) {
          if (isNaN(total_redemption) || !isFinite(total_redemption)) {
            this.$toasted.show("total redemption must be a number");
            return false;
          }
        }
        //total_redemption

        if (
          total_redemption === null ||
          total_redemption === "" ||
          total_redemption === undefined
        ) {
          this.$toasted.show("Please enter total redemption");
          return false;
        }
        return true;
      },
      convertTime(date, time) {
        const d = moment(date).format("YYYY-MM-DD");
        const newdate = moment(d + " " + time).format();
        return newdate;
      },
      getCinemas: async function() {
        this.cinemas = [];
        try {
          let payload = {
            tableName: "ms_cinemas",
            cine_is_active: "Y",
          };
          const response = await MasterService.GetActiveList(payload);
          const { data } = response;
          if (data.status && data.Records.length) {
            this.cinemas = [...data.Records];
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log(error, "from cinemas");
        }
      },

      // onChangeWeekdays: function (event, keyname) {

      //   if (keyname !== "selectAll") {
      //     this.weekDays["selectAll"] = false;
      //   }
      //   if (keyname === "selectAll" && event) {
      //     Object.keys(this.weekDays).map((x) => {
      //       x !== "selectAll" ? (this.weekDays[x] = true) : "";
      //     });
      //   } else if (keyname === "selectAll" && !event) {
      //     Object.keys(this.weekDays).map((x) => {
      //       x !== "selectAll" ? (this.weekDays[x] = false) : "";
      //     });
      //   } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
      //     this.weekDays["selectAll"] = false;
      //   }
      // },

      OnFinalSubmit: async function() {
        this.submitted = true;
        if (!this.voucherObj.voucher_name) {
          console.log(
            "this.voucherObj.voucher_name",
            this.voucherObj.voucher_name
          );
          return this.$toasted.show("Plese enter voucher name");
        } else if (!this.voucherObj.voucher_code) {
          return this.$toasted.show("Plese enter voucher code");
        }
        if (!this.validateVoucherAmount()) {
          return;
        }

        if (!this.voucherObj.voucher_from_date) {
          this.$toasted.show("Please select voucher start date");
          this.custom_errors.voucher_start_date_error =
            "Please select voucher start date";
          return;
        } else if (!this.voucherObj.voucher_to_date) {
          this.$toasted.show("Please select voucher end date");
          this.custom_errors.voucher_end_date_error =
            "Please select voucher end date";
          return;
        } else if (!this.voucherObj.voucher_from_time) {
          this.$toasted.show("Please select voucher start time");
          this.custom_errors.voucher_start_time_error =
            "Please select voucher start time";
          return;
        } else if (!this.voucherObj.voucher_to_time) {
          this.$toasted.show("Please select voucher end time");
          this.custom_errors.voucher_end_time_error =
            "Please select voucher end time";
          return;
        }

        if (this.voucherObj.sales_channels.length == 0) {
          return this.$toasted.show(
            `select atleast one user for redemption outlet`
          );
        }
        // if (this.voucherObj.applicable_merchandises.length == 0) {
        //   return this.$toasted.show(
        //     `select atleast one merchandise`
        //   );
        // }

        this.voucherObj.voucher_from_time = moment(
          this.voucherObj.voucher_from_time,
          "HH:mm"
        ).isValid()
          ? this.voucherObj.voucher_from_time
          : "00:00";

        this.voucherObj.voucher_to_time = moment(
          this.voucherObj.voucher_to_time,
          "HH:mm"
        ).isValid()
          ? this.voucherObj.voucher_to_time
          : "23:59";

        let applicableCinemasIds = this.voucherObj.applicable_cinemas.map(
          (cine) => cine.cine_id
        );
        let applicableSalesChannelIds = this.voucherObj.sales_channels.map(
          (user) => user.user_id
        );
        //let applicableMerchandiesIds = this.voucherObj.applicable_merchandises.map(merch => merch.merchandise_id);

        let voucher_days = { ...this.weekDays };
        let finalObj = {
          m_voucher_id: this.voucherObj.m_voucher_id,
          voucher_name: this.voucherObj.voucher_name,
          voucher_alt_name: this.voucherObj.voucher_alt_name,
          voucher_code: this.voucherObj.voucher_code,
          voucher_amount: this.voucherObj.voucher_amount,
          is_percantage: this.voucherObj.is_percantage,
          min_bill_amount: this.voucherObj.min_bill_amount,
          max_redemption_amount: this.voucherObj.max_redemption_amount,
          total_redemption: this.voucherObj.total_redemption,
          voucher_from_date: moment(this.voucherObj.voucher_from_date).format(
            "YYYY-MM-DD"
          ),
          // voucher_start_date_time: voucherStartDate,
          // voucher_end_date_time: voucherEndDate,
          voucher_from_time: this.voucherObj.voucher_from_time,
          voucher_to_date: moment(this.voucherObj.voucher_to_date).format(
            "YYYY-MM-DD"
          ),
          voucher_to_time: this.voucherObj.voucher_to_time,
          voucher_is_active: this.voucherObj.voucher_is_active,
          applicable_cinemas: applicableCinemasIds,
          sales_channels: applicableSalesChannelIds,
          //applicable_merchandises: applicableMerchandiesIds
        };
        console.log({ "Final-Output": finalObj, weeks: voucher_days });

        let loader = this.$loading.show();
        const response = await MarketingService.addVouchersMerch(finalObj);
        loader.hide();
        const { data } = response;
        console.log("data", data);

        if (data.status) {
          this.$router.push({
            path: "/vouchers/get-vouchers-merch",
          });
        }
        return this.$toasted.show(data.message);
      },
    },
  };
</script>

<style>
  .custom-date .btn-clearDate {
    right: 30px !important;
  }

  .customDisabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .new-border {
    border: 2px solid #b1b4b8;
  }

  label {
    color: black !important;
  }

  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }

  .internal-border {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
    width: 100%;
  }

  .back {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MerchVouchers/addVouchersMerch.vue